'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filter2 = require('./Filter');

var _Filter3 = _interopRequireDefault(_Filter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RangeFilter = (function (_Filter) {
  _inherits(RangeFilter, _Filter);

  /**
   * TODO: throw appropiate errors
   */

  function RangeFilter(id, options) {
    _classCallCheck(this, RangeFilter);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(RangeFilter).call(this, id, options));

    if (options.type !== 'range') {
      throw new Error('The type option for the \'' + id + '\' filter is not range');
    }

    if (options.field === undefined) {
      throw new Error('The field option for the \'' + id + '\' filter is undefined');
    } else if (typeof options.field !== 'string') {
      throw new Error('The field option for the \'' + id + '\' filter is not a string');
    }

    _this._field = options.field;

    if (options.params === undefined) {
      throw new Error('The params option for the \'' + id + '\' filter is undefined');
    } else if (_typeof(options.params) !== 'object') {
      throw new Error('The params option for the \'' + id + '\' filter is not an object');
    }

    // the minimum of the range
    if (options.params.min === undefined) {
      throw new Error('The min params option for the \'' + id + '\' filter is undefined');
    }
    _this._min = options.params.min;

    // the maximum of the range
    if (options.params.min === undefined) {
      throw new Error('The max params option for the \'' + id + '\' filter is undefined');
    }
    _this._max = options.params.max;
    return _this;
  }

  /**
   * TODO: throw appropiate errors
   */

  _createClass(RangeFilter, [{
    key: 'filter',
    value: function filter(unit, inputValues) {
      if (inputValues[this._field] === undefined) {
        // skip over the filter if no input
        return true;
      } else if (_typeof(inputValues[this._field]) !== 'object') {
        throw new Error('The input for the \'' + this._id + '\' filter is not an object');
      }

      if (unit[this._field] === undefined) {
        console.log(unit);
        throw new Error(this._field + ' not found for unit above');
      }

      var min = this._min;
      if (inputValues[this._field].min === undefined) {
        throw new Error('The min input for the \'' + this._id + '\' filter is undefined');
      } else {
        if (inputValues[this._field].min < min) {
          throw new RangeError('Min input (' + inputValues[this._field].min + ') of \'' + this._id + '\' is less than the default minimum (' + this._min + ')');
        }
        min = inputValues[this._field].min;
      }

      var max = this._max;
      if (inputValues[this._field].max === undefined) {
        throw new Error('The max input for the \'' + this._id + '\' filter is undefined');
      } else {
        if (inputValues[this._field].max > max) {
          throw new RangeError('Max input (' + inputValues[this._field].max + ') of \'' + this._id + '\' is greater than the default maximum (' + this._max + ')');
        }
        max = inputValues[this._field].max;
      }

      // Convert this to a float to be able to do comparison
      var unitValue = parseFloat(unit[this._field]);

      return unitValue >= min && unitValue < max;
    }
  }]);

  return RangeFilter;
})(_Filter3.default);

exports.default = RangeFilter;
//# sourceMappingURL=../filters/RangeFilter.js.map